class Diversification {
    properties;
    marketType;
    investmentStrategy;
    propertyUsageType;
    constructor(data) {
        this.properties = data.properties;
        this.marketType = data.marketType;
        this.investmentStrategy = data.investmentStrategy;
        this.propertyUsageType = data.propertyUsageType;
    }
}
export default Diversification;
